// Freja eID - download/signup
export const FREJA_URL_SV = "https://frejaeid.com/skaffa-freja-eid/";
export const FREJA_URL_EN = "https://frejaeid.com/en/get-freja-eid/";
// BankID - download/signup
export const BANK_ID_URL_EN = "https://www.bankid.com/en/privat/skaffa-bankid";
export const BANK_ID_URL_SV = "https://www.bankid.com/privat/skaffa-bankid";
// Freja eID - protected identity instructions
export const FREJA_EID_PROTECTED_ID_URL_EN = "https://frejaeid.com/en/freja-for-swedes-with-protected-identities/";
export const FREJA_EID_PROTECTED_ID_URL_SV = "https://frejaeid.com/freja-for-svenskar-med-skyddad-identitet/";
// Freja eID - foreign citizens instructions
export const FREJA_EID_FOREIGN_INSTRUCTION_URL_EN = "https://org.frejaeid.com/en/an-e-id-for-foreign-citizens/";
export const FREJA_EID_FOREIGN_INSTRUCTION_URL_SV = "https://org.frejaeid.com/en-e-legitimation-for-utlandska-medborgare/";
